import { Spinner } from "@/icons";

export const Loader = ({
  loading = false,
  className,
}: {
  loading?: boolean;
  className?: string;
}) => {
  return <div className={className}>{loading ? <Spinner /> : null}</div>;
};
